import InfoPage from './InfoPage';

export default InfoPage;
